"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSection = exports.ContentRow = exports.ContentCol = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "containerElement", "float", "noGutters", "padded", "verticalAlign"],
    _excluded2 = ["children", "className", "containerElement", "expand", "float", "gutters", "shrink"],
    _excluded3 = ["children", "className", "containerElement"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ContentRow = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      _ref$containerElement = _ref.containerElement,
      ContainerElement = _ref$containerElement === void 0 ? 'div' : _ref$containerElement,
      float = _ref.float,
      noGutters = _ref.noGutters,
      padded = _ref.padded,
      verticalAlign = _ref.verticalAlign,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'autofit-row', (_classNames = {
      'autofit-float': float === true
    }, _defineProperty(_classNames, "autofit-float-".concat(float), typeof float === 'string'), _defineProperty(_classNames, 'autofit-padded', padded), _defineProperty(_classNames, 'autofit-padded-no-gutters', noGutters === true), _defineProperty(_classNames, "autofit-padded-no-gutters-".concat(noGutters), typeof noGutters === 'string'), _defineProperty(_classNames, "autofit-row-".concat(verticalAlign), verticalAlign), _classNames)),
    ref: ref
  }), children);
});

exports.ContentRow = ContentRow;
ContentRow.displayName = 'ClayContentRow';

var ContentCol = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$containerElemen = _ref2.containerElement,
      ContainerElement = _ref2$containerElemen === void 0 ? 'div' : _ref2$containerElemen,
      expand = _ref2.expand,
      float = _ref2.float,
      gutters = _ref2.gutters,
      shrink = _ref2.shrink,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'autofit-col', _defineProperty({
      'autofit-col-expand': expand,
      'autofit-col-gutters': gutters,
      'autofit-col-shrink': shrink
    }, "autofit-col-".concat(float), float)),
    ref: ref
  }), children);
});

exports.ContentCol = ContentCol;
ContentCol.displayName = 'ClayContentCol';

var ContentSection = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      className = _ref3.className,
      _ref3$containerElemen = _ref3.containerElement,
      ContainerElement = _ref3$containerElemen === void 0 ? 'div' : _ref3$containerElemen,
      otherProps = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'autofit-section'),
    ref: ref
  }), children);
});

exports.ContentSection = ContentSection;
ContentSection.displayName = 'ClayContentSection';